import type { FunctionComponent } from "react";

import type { Edition } from "shared/lib/edition";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";

import { StyledHeaderOnelineMenuContainer } from "./styles";

export type HeaderFeaturesOneLineMenuProps = {
  appBarVariant?: AppBarVariant;
  initEdition?: Edition;
};

export const HeaderFeaturesOneLineMenu: FunctionComponent<HeaderFeaturesOneLineMenuProps> = ({
  appBarVariant,
  initEdition,
}) => <StyledHeaderOnelineMenuContainer appBarVariant={appBarVariant} initEdition={initEdition} />;

HeaderFeaturesOneLineMenu.displayName = "HeaderFeaturesOneLineMenu";
